import { createSelector } from 'reselect';

import { selectPreviewRealtyIds } from './selectPreviewRealtyIds';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { IApplicationState } from '../../types/redux';

/** Селектору нужны только эти ветки стора; узкий тип позволяет собирать стейт в тестах без приведения типов. */
type TPreviewOffersSourceState = Pick<IApplicationState, 'previewOffers' | 'hiddenObjects'>;

const selectOffersInPreview = (state: TPreviewOffersSourceState) => state.previewOffers.offers;
const selectHiddenOfferIds = (state: TPreviewOffersSourceState) => state.hiddenObjects.ids;

/**
 * Объявления выбранного пина для превью, в порядке объявлений пина. Берутся только из хранилища превью
 * (почему не из листинга - см. IPreviewOffersState). Ещё не загруженные и скрытые пропускаются.
 */
export const selectPreviewOffers = createSelector(
  selectPreviewRealtyIds,
  selectOffersInPreview,
  selectHiddenOfferIds,
  (realtyIds, offersInPreview, hiddenIds): IDailyRentOfferForMobileSite[] =>
    realtyIds.reduce<IDailyRentOfferForMobileSite[]>((pinOffers, realtyId) => {
      const offer = offersInPreview.find(offerInPreview => offerInPreview.id === realtyId);

      if (offer && !hiddenIds.includes(realtyId)) {
        pinOffers.push(offer);
      }

      return pinOffers;
    }, []),
);
